/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2021. All Rights Reserved.
 #*
 #*===================================================================
 */

import { createFeatureSelector, createSelector } from '@ngrx/store';

import { Client } from '@truckstop-tms/zuum-lib';
import { CLIENT_LIST_FEATURE_KEY } from '../reducers/clients-tms.reducer';
import { ClientsTmsState } from '../reducers/clients-tms.reducer';

export const getClientsTmsState = createFeatureSelector<ClientsTmsState>(CLIENT_LIST_FEATURE_KEY);

export const getClientsTms = createSelector(getClientsTmsState, (state: ClientsTmsState): Client[] => state.clients);
export const getTotalNumberOfClients = createSelector(
  getClientsTmsState,
  (state: ClientsTmsState): number => state.totalNumberOfClients
);
